import React, { useCallback, useEffect, useState } from 'react'
import { getStatus } from './status';

function TaskStatus({ taskData }) {
    const [refundedAmount, setRefundedAmount] = useState(false);
    const [curruntStatus, setCurruntStatus] = useState();

    useEffect(() => {
        if (taskData) {
            if (taskData?.status === 'completed') {
                taskData.isClaimed = true
            } else {
                taskData.isClaimed = false
            }

            const status = getStatus(taskData, 'taskDetail');
            setCurruntStatus(status);
            console.log(status, 'statusstatusstatus');
        }
    }, [taskData])
    function formatStatus(status) {
        // Separate camelCase words and capitalize the first letter of each word
        const formatted = status?.replace(/([a-z])([A-Z])/g, '$1 $2')  // Adds space between camelCase words
            .split(' ')  // Split into words
            .map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))  // Capitalize first letter
            .join(' ');  // Join the words back together

        return formatted;
    }
  return (
      <>{formatStatus(curruntStatus)}</>
  )
}

export default TaskStatus